@if (page$ | async; as page) {
<div class="d-flex container justify-content-between align-content-center pt-2 mt-3">
  <div class="mb-3">
    <h3>Groupes</h3>
  </div>
</div>
<div class="d-flex container justify-content-between align-content-center">
  <input
    type="text"
    class="form-control search-bar"
    placeholder="Rechercher un groupe ..."
    [(ngModel)]="searchTerm"
    (input)="filterGroups()" />
  <button class="btn btn-outline-primary" (click)="createGroup()">
    <div class="d-flex button-text align-items-center">
      <span class="material-symbols-outlined">group_add</span>
      <small class="d-none d-lg-block">Nouveau</small>
    </div>
  </button>
</div>
<div class="d-flex flex-column container">
  @if (page.content.length !== 0) {
  <div class="table-responsive">
    <div class="p-3 group-card d-flex flex-row align-items-center justify-content-between">
      <span class="group-name"><b>Nom</b></span>
      <span class="group-description"><b>Description</b></span>
      <span class="group-candidates"><b>Nombre de candidats</b></span>
    </div>
    @if (filteredGroups.length > 0) { @for (group of filteredGroups; track group) {
    <div
      class="card mb-2 p-3 group-card flex-row"
      [routerLink]="'/groups/' + group.id"
      [state]="{ group: group }"
      style="cursor: pointer">
      <span class="group-name">{{ group.name }}</span>
      <span class="group-description">{{ group.description }}</span>
      <span class="group-candidates">{{ group.candidatesNumber }}</span>
    </div>
    } } @else {
    <syn-empty-page message="La liste des groupes est vide" />
    }
  </div>
  } @else {
  <syn-empty-page message="La liste des groupes est vide" />
  }
</div>
<syn-pagination [page]="page" queryParamsHandling="merge" />
}
